import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import iMenuHeadTitle from "./title";
import { mapState, mapGetters } from 'vuex';
import { getStyle } from 'view-design/src/utils/assist';
import clickItem from "../mixins/click-item";
import { on, off } from 'view-design/src/utils/dom';
import { throttle } from 'lodash';
export default {
  name: 'iMenuHead',
  components: {
    iMenuHeadTitle: iMenuHeadTitle
  },
  mixins: [clickItem],
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('admin/layout', ['isMobile'])), mapState('admin/menu', ['headerName'])), mapGetters('admin/menu', ['filterHeader'])),
  data: function data() {
    return {
      handleResize: function handleResize() {},
      isMenuLimit: false,
      menuMaxWidth: 0 // 达到这个值后，menu 就显示不下了
    };
  },
  methods: {
    handleGetMenuHeight: function handleGetMenuHeight() {
      var menuWidth = parseInt(getStyle(this.$el, 'width'));
      var $menu = this.$refs.menu;
      if ($menu) {
        var menuHeight = parseInt(getStyle(this.$refs.menu.$el, 'height'));
        if (menuHeight > 64) {
          if (!this.isMenuLimit) {
            this.menuMaxWidth = menuWidth;
          }
          this.isMenuLimit = true;
        }
      } else if (menuWidth >= this.menuMaxWidth) {
        this.isMenuLimit = false;
      }
    }
  },
  watch: {
    filterHeader: function filterHeader() {
      this.handleGetMenuHeight();
    },
    isMobile: function isMobile() {
      this.handleGetMenuHeight();
    }
  },
  mounted: function mounted() {
    this.handleResize = throttle(this.handleGetMenuHeight, 100, {
      leading: false
    });
    on(window, 'resize', this.handleResize);
    this.handleGetMenuHeight();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.handleResize);
  }
};